<script setup>
import { usePageHead } from '@/composables/usePageHead'
import content from '@/content/donate.yml'
usePageHead(content)
</script>

<template>
  <div class="donate container">
    <section class="page-intro">
      <h1>{{ content.hero.heading }}</h1>
      <p class="lead">{{ content.hero.body }}</p>
      <p class="notice">{{ content.hero.notice }}</p>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.donate { padding-block: $space-8; text-align: center; }
.page-intro {
  padding-block: $space-16;
  h1 { @include page-title; }
}
.lead { font-size: $font-size-lg; color: var(--color-text); margin-bottom: $space-6; }
.notice { color: var(--color-text-muted); font-style: italic; }
</style>
